import React from "react";

import { StrainCardPlaceholder } from "@/components/botanic/StrainCard";
import ButtonPlaceholder from "@/components/ButtonSkeleton";

const StrainPlaceholderList: React.FC<{
  count?: number;
}> = ({ count = 1 }) => (
  <>
    {new Array(count).fill(null).map((_, i) => {
      return (
        <div className="col md:col-1/3 mb-md" key={i}>
          <div className="h-full shadow-low rounded">
            <StrainCardPlaceholder
              orientation={{ desktop: "vertical", mobile: "horizontal" }}
            />
            <div className="px-md mb-md">
              <ButtonPlaceholder height="36" />
            </div>
          </div>
        </div>
      );
    })}
  </>
);

export default StrainPlaceholderList;
